// Firebase configuration interface
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

interface FirebaseConfig {
	apiKey: string
	authDomain: string
	projectId: string
	storageBucket: string
	messagingSenderId: string
	appId: string
	measurementId?: string // Optional since it's noted as optional in the comment
}

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig: FirebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
	appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
